var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnglish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_170_217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H31V23H0V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63281 0L15.4516 8.67292L27.2219 0H31V2.97083L19.375 11.5479L31 20.0771V23H27.125L15.5 14.4229L3.92344 23H0V20.125L11.5766 11.5958L0 3.06667V0H3.63281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5375 13.4646L31 21.0833V23L17.8734 13.4646H20.5375ZM11.625 14.4229L11.9156 16.1L2.61562 23H0L11.625 14.4229ZM31 0V0.14375L18.9391 9.15208L19.0359 7.04375L28.5781 0H31ZM0 0L11.5766 8.43333H8.67031L0 2.0125V0Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6734 0V23H19.4234V0H11.6734ZM0 7.66667V15.3333H31V7.66667H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9.24792V13.8479H31V9.24792H0ZM13.2234 0V23H17.8734V0H13.2234Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170_217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/English.11c83e1c930452532864fd4daa322a9c.svg";
export { ForwardRef as ReactComponent };